import React from 'react';
import Carousel from 'components/common/Carousel';

function renderPics(pictures) {
  return pictures.map((pic,i) => (
    <div key={i} className="listing-img" style={{backgroundImage: `url(${pic.large}`}}/>
  ));
}

const slickOptions = {
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true
};

export default ({ pictures }) => {
  return (
    <Carousel className="single-listing-carousel" slickOptions={slickOptions}>
      {renderPics(pictures)}
    </Carousel>
  );
};


// WEBPACK FOOTER //
// ./src/components/SingleListingCarousel.js